<template>
  <v-sheet
      @click="handleExpand"
      class=" pointer wsRoundedHalf mx-auto mb-4"
      max-width="782"

  >
    <div class="d-flex justify-space-between align-center px-4 py-6">
      <h3 class="wsDARKER">{{ item.title }}</h3>
      <v-icon :color="wsDARKER">mdi-chevron-{{ expanded ? 'up' : 'down' }}</v-icon>
    </div>

    <v-expand-transition>
      <div v-if="expanded" class="pa-4 py-6" style="border-top : 1px solid var(--wsBACKGROUND)">
        <h4 class="font-weight-regular wsDARKER" v-html="item.content"></h4>
      </div>
    </v-expand-transition>


  </v-sheet>
</template>
<script>
export default {
  name: "partnerAccordionItem",
  props : {
    item : {
      type : Object,
      default() { return {} }
    },
    collapseTrigger : {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      expanded : false,
      stopTrigger : false,
    }
  },
  watch : {
    collapseTrigger() {
      if (this.stopTrigger) {
        return
      }
      this.expanded = false
    }
  },
  methods : {
    handleExpand() {
      this.expanded = !this.expanded
      if (this.expanded) {
        this.stopTrigger = true
        setTimeout(() => {
          this.stopTrigger = false
        },300)
        this.$emit('expand')
      }
    }
  },
  mounted() {
    if (this.item.expanded) {
      this.expanded = true
    }
  }
}
</script>



<style scoped>

</style>